// Official Bahamas Taxi Zone Rates (Government Regulated)
// Rates are in BSD (Bahamian Dollar) which is 1:1 with USD

export const taxiRates = {
  // Base rates include 2 passengers and 2 pieces of luggage per passenger
  basePassengers: 2,
  baseLuggage: 2,
  
  // Additional charges
  extraPassengerFee: 5, // per passenger beyond 2
  extraLuggageFee: 2, // per bag beyond base allowance
  golfBagFee: 3, // per golf bag
  paradiseBridgeToll: 2, // toll to Paradise Island
  
  // Waiting/stop charges
  waitingCharge: 1, // per minute for stops (grocery store, liquor store, etc.)
  
  // Hourly rates
  islandTourRate: 80, // per hour for island tours
  hourlyRate: 50, // per hour for general use
  
  // Airport to destination rates (from Nassau International Airport)
  airportRates: [
    { destination: 'Cable Beach', rate: 22, zone: 'cable-beach' },
    { destination: 'Baha Mar Resort', rate: 25, zone: 'baha-mar' },
    { destination: 'Downtown Nassau', rate: 32, zone: 'downtown' },
    { destination: 'Paradise Island', rate: 38, zone: 'paradise-island', includesToll: true },
    { destination: 'Atlantis Resort', rate: 38, zone: 'atlantis', includesToll: true },
    { destination: 'Prince George Dock (Cruise Port)', rate: 32, zone: 'cruise-port' },
    { destination: 'Lyford Cay', rate: 24, zone: 'lyford-cay' },
    { destination: 'South Ocean', rate: 26, zone: 'south-ocean' },
    { destination: 'Coral Harbor', rate: 26, zone: 'coral-harbor' }
  ],
  
  // Zone to zone rates
  zoneToZoneRates: [
    { from: 'Cable Beach', to: 'Downtown Nassau', rate: 18 },
    { from: 'Cable Beach', to: 'Paradise Island', rate: 24, includesToll: true },
    { from: 'Downtown Nassau', to: 'Paradise Island', rate: 13, includesToll: true },
    { from: 'Paradise Island', to: 'Downtown Nassau', rate: 9 },
    { from: 'Downtown Nassau', to: 'Cable Beach', rate: 18 },
    { from: 'Paradise Island', to: 'Cable Beach', rate: 24 },
    { from: 'Baha Mar', to: 'Downtown Nassau', rate: 20 },
    { from: 'Baha Mar', to: 'Paradise Island', rate: 26, includesToll: true },
    { from: 'Atlantis', to: 'Downtown Nassau', rate: 9 },
    { from: 'Atlantis', to: 'Cable Beach', rate: 24 }
  ],
  
  // Hourly rental rate for tours/multiple stops
  hourlyRate: 50, // per hour for van
  
  // Waiting time charge
  waitingCharge: 1.50 // per minute
};

// Function to calculate total fare
export const calculateFare = (pickup, dropoff, passengers = 2, extraBags = 0, isGolfBag = false) => {
  let baseFare = 0;
  let tollFee = 0;
  let extraPassengerFee = 0;
  let extraBagFee = 0;
  
  // Normalize location names for matching
  const normalizeLocation = (loc) => {
    return loc.toLowerCase().trim();
  };
  
  const pickupNorm = normalizeLocation(pickup);
  const dropoffNorm = normalizeLocation(dropoff);
  
  // Check if it's an airport trip
  if (pickupNorm.includes('airport') || pickupNorm.includes('lpia') || pickupNorm.includes('nassau international')) {
    const airportRate = taxiRates.airportRates.find(route => 
      normalizeLocation(route.destination).includes(dropoffNorm) || 
      dropoffNorm.includes(normalizeLocation(route.destination))
    );
    
    if (airportRate) {
      baseFare = airportRate.rate;
      if (airportRate.includesToll) {
        tollFee = taxiRates.paradiseBridgeToll;
      }
    }
  } 
  // Check reverse - destination is airport
  else if (dropoffNorm.includes('airport') || dropoffNorm.includes('lpia') || dropoffNorm.includes('nassau international')) {
    const airportRate = taxiRates.airportRates.find(route => 
      normalizeLocation(route.destination).includes(pickupNorm) || 
      pickupNorm.includes(normalizeLocation(route.destination))
    );
    
    if (airportRate) {
      baseFare = airportRate.rate;
      if (airportRate.includesToll) {
        tollFee = taxiRates.paradiseBridgeToll;
      }
    }
  }
  // Check zone to zone
  else {
    const zoneRate = taxiRates.zoneToZoneRates.find(route => 
      (normalizeLocation(route.from).includes(pickupNorm) || pickupNorm.includes(normalizeLocation(route.from))) &&
      (normalizeLocation(route.to).includes(dropoffNorm) || dropoffNorm.includes(normalizeLocation(route.to)))
    );
    
    if (zoneRate) {
      baseFare = zoneRate.rate;
      if (zoneRate.includesToll) {
        tollFee = taxiRates.paradiseBridgeToll;
      }
    }
  }
  
  // Calculate additional passenger fee (passengers beyond 2)
  if (passengers > taxiRates.basePassengers) {
    extraPassengerFee = (passengers - taxiRates.basePassengers) * taxiRates.extraPassengerFee;
  }
  
  // Calculate extra luggage fee
  if (extraBags > 0) {
    extraBagFee = extraBags * (isGolfBag ? taxiRates.golfBagFee : taxiRates.extraLuggageFee);
  }
  
  const total = baseFare + tollFee + extraPassengerFee + extraBagFee;
  
  return {
    baseFare,
    tollFee,
    extraPassengerFee,
    extraBagFee,
    total,
    currency: 'BSD/USD',
    found: baseFare > 0
  };
};

// Get all unique locations for dropdowns
export const getAllLocations = () => {
  const locations = new Set(['Nassau International Airport (LPIA)']);
  
  taxiRates.airportRates.forEach(route => {
    locations.add(route.destination);
  });
  
  taxiRates.zoneToZoneRates.forEach(route => {
    locations.add(route.from);
    locations.add(route.to);
  });
  
  return Array.from(locations).sort();
};
